import { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { FinanceStatus } from '@kanda-libs/ks-frontend-services';

import jobSelectors from 'store/selectors/job';

export interface JobRevertButtonContainerProps {
  children: JSX.Element;
}

const JobRevertButtonContainer: FunctionComponent<JobRevertButtonContainerProps> =
  function ({ children }) {
    const job = useSelector(jobSelectors.getEntity);

    const showContent = [
      'sat_note_sent',
      'sat_note_viewed',
      'sat_note_signed',
      'sat_note_delayed',
      'sat_note_lender_review',
    ].includes(job?.finance_status || '');

    if (!showContent) return <></>;

    return <>{children}</>;
  };

export default JobRevertButtonContainer;
